// @flow
import { fork } from 'redux-saga/effects';
import getOpenStatsSaga from './getOpenStats';

export default function* openStatsSaga() {
  yield fork(getOpenStatsSaga);
}
